import React from "react";
import Dropdown from "react-select";
import "./../textField/textField.css";

const Select = ({ className, textAlign, label, selectedID, arrData, handleSelect, autoSelect,isDisabled}) => {
  return (
    <div className="Entrada">
      <label style={{textAlign:textAlign}} htmlFor="react-select">
        <strong>{label}:</strong>
      </label>
      <Dropdown
        autoFocus={autoSelect}
        id="react-select"
        className={className}
        onChange={(e) => handleSelect(e.value,e.label)}
        value={selectedID}
        options={arrData}
        isSearcheable
        isDisabled={isDisabled}
        placeholder="Selecione..."
        theme={(theme) => ({
          ...theme,
          height: 1,
          borderRadius: 1,
          colors: {
            ...theme.colors,
            primary25: "#05CA83cc",
            primary: "#05CA83",
          },
        })}
      />
    </div>
  );
};
export default Select;